import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropdown-menu-hr',
  templateUrl: './dropdown-menu-hr.component.html',
  styleUrls: ['./dropdown-menu-hr.component.scss']
})
export class DropdownMenuHrComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
